export function getTaskSpentTime(state) {
  return id => {
    return state.tasksTimer[id]
  }
}